export default __webpack_public_path__ + "static/media/Gobold Hollow Bold Italic.029a1340.otf";